module.exports = __webpack_public_path__ + "img/Trendingdown.8d8d090b.svg";